import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget'

import style from './OrderManageFromFooter.module.scss'

type TOrderManageFromFooter = {
  handleBack: () => void
  isButtonDisabled: boolean
  isLoading: boolean
}

// нижний блок с кнопками для форм упраления заявкой

export const OrderManageFromFooter = ({
  handleBack,
  isButtonDisabled,
  isLoading,
}: TOrderManageFromFooter) => {
  return (
    <div className={style.btnsWrapper}>
      <Button
        variant='contained'
        disabled={isButtonDisabled}
        type='submit'
        color='primary'
        data-testid='manage-form-submit'
      >
        {isLoading && <LoaderInCentalPosition />}
        Отправить
      </Button>
      <Button
        variant='text'
        onClick={handleBack}
        className={style.backButton}
        disabled={isLoading}
        data-testid='manage-form-back'
      >
        Назад
      </Button>
    </div>
  )
}
